import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext.jsx';
import styles from './Login.module.scss';
import mwuLogo from '../StoreForm/mwu-logo.webp';

const Login = () => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData);

    if (result.success) {
      // Login successful - the AuthContext will handle the state update
      // and the ProtectedRoute will automatically redirect
      // Add a small delay to ensure state updates properly
      setTimeout(() => {
        setLoading(false);
      }, 100);
    } else {
      setError(result.error || 'Login failed. Please check your credentials.');
      setLoading(false);
    }
  };

  return (
    <div className={styles['login-container']}>
      <div className={styles['login-card']}>
        <div className={styles['login-header']}>
          <h2>Mid-West University</h2>
          <h3>क्लाउड ल्याब स्टोर व्यवस्थापन प्रणाली</h3>
          <div className={styles['logo-container']}>
            <img src={mwuLogo} alt="MWU Logo" className={styles['login-logo']} />
          </div>
          <p>Please login to continue</p>
        </div>
        
        <form onSubmit={handleSubmit} className={styles['login-form']}>
          {error && <div className={styles['error-message']}>{error}</div>}
          
          <div className={styles['form-group']}>
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Enter your username"
            />
          </div>
          
          <div className={styles['form-group']}>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
            />
          </div>
          
          <button 
            type="submit" 
            className={styles['login-button']}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div className={styles['footer']}>
          <p>Publishing rights reserved by Cloud Lab Private Limited</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
